var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSimpleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 155,
    viewBox: "0 0 94 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8807 124H6.0625V30.9091H41.517C51.0928 30.9091 59.3655 32.7727 66.3352 36.5C73.3352 40.197 78.7292 45.5303 82.5171 52.5C86.3352 59.4394 88.2443 67.7576 88.2443 77.4545C88.2443 87.1515 86.3504 95.4848 82.5625 102.455C78.7746 109.394 73.411 114.727 66.4716 118.455C59.5322 122.152 51.3352 124 41.8807 124ZM31.3352 102.545H40.9716C45.5777 102.545 49.5019 101.803 52.7443 100.318C56.017 98.8333 58.5019 96.2727 60.1989 92.6364C61.9261 89 62.7898 83.9394 62.7898 77.4545C62.7898 70.9697 61.911 65.9091 60.1534 62.2727C58.4261 58.6364 55.8807 56.0758 52.517 54.5909C49.1837 53.1061 45.0928 52.3636 40.2443 52.3636H31.3352V102.545Z",
    fill: "#009DB4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 112,
    r: 12.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_6",
    x: 2.0625,
    y: 30.9091,
    width: 90.1818,
    height: 101.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_6",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimpleWhite);
export default __webpack_public_path__ + "static/media/logo_simple_white.fcca7f7997a153156e0d7007127d6220.svg";
export { ForwardRef as ReactComponent };